var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPixelRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.6 10h140.2v138.7H219.6V10zM359.8 148.7H500v140.2H359.8V148.7zM500 288.9h140.2v140.2H500V288.9zM500 569.4h140.2v140.2H500V569.4zM359.8 709.6H500v140.2H359.8V709.6zM219.6 849.8h140.2V990H219.6V849.8zM640.2 429.1h140.2v140.2H640.2V429.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelRight);
export default __webpack_public_path__ + "static/media/pixelRight.dcbbf36baa17d314e9e4e6d0d7e2a205.svg";
export { ForwardRef as ReactComponent };